import * as React from "react";

import { HttpClient } from "@/shared/http";

interface Context {
  httpClient: HttpClient;
  setResourceOwnerId: (resourceOwnerId: string | undefined) => void;
}

export const HttpClientContext = React.createContext<Context | null>(null);

export const useHttpClient = (): Context => {
  const httpClientContext = React.useContext(HttpClientContext);
  if (!httpClientContext) {
    throw new Error("HttpClientContext is null", {
      cause: {
        reason: "HttpClientContext is accessed outside a HttpClientProvider",
      },
    });
  }
  return httpClientContext;
};
